import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { withStyles } from '@material-ui/styles'
import { Divider } from '@material-ui/core';

const styles = theme => ({
    dividerHorizontal: {
        [theme.breakpoints.up('sm')]: {
            display: 'none'
        },
        [theme.breakpoints.only('xs')]: {
            display: 'flex',
            width: '100px',
            marginTop: '75px',
            width: '2px',
            backgroundColor: '#e4e1e1',
            border: 'none'
        }
    },
    dividerVertical: {
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            height: '100px',
            marginTop: '75px',
            width: '2px',
            backgroundColor: '#e4e1e1',
            border: 'none'
        },
        [theme.breakpoints.only('xs')]: {
            display: 'none'
        }
    },
    calloutContainer: {
        [theme.breakpoints.up('md')]: {
            marginLeft: "25%",
            marginRight: "25%"
        },
        [theme.breakpoints.only('sm')]: {
            marginLeft: "5%",
            marginRight: "5%"
        },
        [theme.breakpoints.only('xs')]: {
            marginLeft: "0%",
            marginRight: "0%"
        }
    },
    calloutText: {
        fontWeight:'bolder',
        fontSize: '47px',
        margin: '0px 0 10px 0'

    },
    calloutTextLongWord: {
        fontWeight:'bolder',
        fontSize: '41px',
        paddingBottom: '8px',
        margin: '0px 0 10px 0'

    },
    calloutSubtitle: {
        margin: '0 10px 0 10px',
        fontSize: '13px'
    },
    calloutTitle: {
        fontSize: '18px'
    }
})


class Callout extends Component {

    constructor(props){
        super(props)
    }
    
    render() {
        
        const {classes} = this.props
        let color1 = this.props.content.CallOut01.CalloutColor.length ? this.props.content.CallOut01.CalloutColor : "black"
        let color2 = this.props.content.CallOut02.CalloutColor.length ? this.props.content.CallOut02.CalloutColor : "black"

        let components = {}


        if(this.props.content.CallOut02.Visible=="0"){
            return(
                <Grid 
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    style={{paddingBottom:'20px'}}>
                    <Grid container item xs={12} sm={12} spacing={1} direction="column" style={{padding:'15px 30px 15px 30px'}} class={classes.calloutContainer}> 
                       <Typography class={classes.calloutTitle} variant="body1" dangerouslySetInnerHTML={{__html: this.props.content.CallOut01.PrimaryText}}></Typography>
                       <Typography class={classes.calloutText} style={{color:color1}} >{this.props.content.CallOut01.CalloutText}</Typography>
                       <Typography class={classes.calloutSubtitle} variant="body2" dangerouslySetInnerHTML={{__html: this.props.content.CallOut01.SecondaryText}}></Typography>
                    </Grid>
                </Grid>
            )
        } else {
            return(
                <Grid 
                container
                direction="row"
                justify="baseline"
                alignItems="flex-start"
                style={{paddingBottom:'20px'}}>
                    <Grid container item xs={12} sm={6} spacing={1} direction="column" style={{padding:'15px 30px 15px 30px'}}> 
                       <Typography class={classes.calloutTitle} variant="body1" dangerouslySetInnerHTML={{__html: this.props.content.CallOut01.PrimaryText}}></Typography>
                       <Typography class={this.props.content.CallOut01.CalloutText.length > 5 ? classes.calloutTextLongWord : classes.calloutText} style={{color:color1}}>{this.props.content.CallOut01.CalloutText}</Typography>
                       <Typography class={classes.calloutSubtitle} variant="body2" dangerouslySetInnerHTML={{__html: this.props.content.CallOut01.SecondaryText}}></Typography>
                    </Grid>
                    <Divider variant="middle" class={classes.dividerHorizontal}/>
                    <Divider variant="middle" orientation="vertical" flexItem="true" class={classes.dividerVertical}/>
                    <Grid container item xs={12} sm={6} spacing={1} direction="column" style={{padding:'15px 30px 15px 30px'}}>
                       <Typography class={classes.calloutTitle} variant="body1" dangerouslySetInnerHTML={{__html: this.props.content.CallOut02.PrimaryText}}></Typography>
                       <Typography class={this.props.content.CallOut02.CalloutText.length > 5 ? classes.calloutTextLongWord : classes.calloutText} style={{color:color2}}>{this.props.content.CallOut02.CalloutText}</Typography>
                       <Typography class={classes.calloutSubtitle} variant="body2" dangerouslySetInnerHTML={{__html: this.props.content.CallOut02.SecondaryText}}></Typography>
                    </Grid>
                </Grid>
            )
        }

        
    }
}

export default withStyles(styles)(Callout)

/*
        {
            "ComponentClass": "TEXTAREA",
            "ComponentFamily": "VARIANT",
            "ComponentType": "CALLOUT",
            "ComponentVisible": "1",
            "ComponentContent": {
                "CallOuts": {
                    "CallOut01": {
                        "PrimaryText": "Top text",
                        "CalloutText": "10%",
                        "SecondaryText": "",
                        "Visible": "1"
                    },
                    "CallOut02": {
                        "PrimaryText": "Callout 2",
                        "CalloutText": "50%",
                        "SecondaryText": "",
                        "Visible": "1"
                    }
                }
            }
        }
*/